/* eslint-disable max-len */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable default-case */
/* eslint-disable no-unused-expressions */
import CodeMirror from 'codemirror';

(function () {
  'use strict';

  // Operator Types
  // start-equals
  // plain
  // error
  // string
  // field-name
  // table-name
  // bracket
  // bracket error
  // operator
  // operator right-operator
  // range-operator
  // number
  // comma
  // environment-variable
  // function-name
  // unfinished-formula error
  // custom-function
  // null

  CodeMirror.defineMode('goformz-formula', () => {
    return {
      startState() {
        return {
          error: null,
          stringType: null,
          stack: [],
          unclosedBrackets: [],
          previousType: null
        };
      },
      token(stream, state) {
        if (!stream) return;

        if (stream.sol()) {
          if (stream.peek() === '=') {
            stream.next();
            state.previousType = 'start-equals';
            return 'start-equals';
          }
          stream.skipToEnd();
          return 'plain';
        }

        // console.log(stream);
        // console.log(state);

        //check for state changes
        if (state.stack.length === 0) {
          //strings
          if (stream.peek() === '"' || stream.peek() === "'") {
            if (!checkIfValueIsAllowed(stream, state)) {
              return errorAndNext(stream, state, 'An operator is required before a string');
            }

            state.stringType = stream.peek();
            stream.next(); // Skip quote
            state.stack.unshift('string');
          }
        }

        //return state
        //stack has
        switch (state.stack[0]) {
          case 'string':
            while (state.stack[0] === 'string' && !stream.eol()) {
              if (stream.peek() === state.stringType) {
                stream.next(); // Skip quote
                if (stream.peek() == state.stringType) {
                  //Skip double quote escape
                  stream.next();
                } else {
                  state.stack.shift(); // Clear flag
                }
              } else if (stream.peek() === '\\') {
                stream.next();
                stream.next();
              } else {
                stream.match(/^.[^\\"']*/);
              }
            }
            state.previousType = 'value';
            return 'string';

          case 'field-name':
            while (state.stack[0] === 'field-name' && !stream.eol()) {
              if (!stream.match(/^[^[\]]+(?=\])/)) {
                state.stack.shift();
              } else {
                state.previousType = 'value';
              }
            }

            // peek ahead to see if this is the start of a table
            if (stream.match(/^\]!/, false)) {
              state.isTable = true;
              return 'table-name';
            }

            return 'field-name';

          case 'table':
            return handleTable(stream, state);
        }

        delete state.isTable;
        delete state.tableHasRange;

        const peek = stream.peek();

        //no stack
        if (peek === '[') {
          if (!checkIfValueIsAllowed(stream, state)) {
            return errorAndNext(stream, state, 'An operator is required before referencing a field');
          }

          stream.next();

          if (stream.match(/^([0-9]+|Column\(\))\]\[/, false)) {
            // peek ahead to see if this is the start of a table
            state.stack.unshift('table');
            state.previousTableType = 'column-start-bracket';
            state.referencingTableWithoutName = true;
          } else {
            state.stack.unshift('field-name');
            state.unclosedBrackets.push({ text: '[', type: 'field', pos: stream.pos });
            state.previousType = 'start-bracket';
          }

          return 'bracket';
        } else if (stream.match(/[-]?\d*\.?\d+/, false)) {
          if (peek === '-' && state.previousType !== 'operator') {
            // if this number is starting with a minus and there is no previous operator, then we need to be treating this as an operator instead
            state.previousType = 'operator';
            stream.next();
            return 'operator';
          }

          // now we can consume the value
          stream.match(/[-]?\d*\.?\d+/, true);

          if (stream.match(/^\w+/)) {
            return error(stream, state);
          }
          if (!checkIfValueIsAllowed(stream, state)) {
            return error(stream, state, 'An operator is required before the number');
          }
          state.previousType = 'value';
          return 'number';
        } else if (['&', '*', '-', '+', '=', '/', '<', '>', '^', '%'].indexOf(peek) > -1) {
          const operatorIsAllowed = checkIfOperatorIsAllowed(stream, state);
          let operator = peek;

          stream.next();

          if (peek === '<' && (stream.peek() === '=' || stream.peek() === '>')) {
            operator += stream.peek();
            stream.next();
          }
          if (peek === '>' && stream.peek() === '=') {
            operator += stream.peek();
            stream.next();
          }

          if (!operatorIsAllowed) {
            return error(stream, state, `Unexpected operator '${operator}'`);
          }

          // % is a right sided operator. It modifies the previous value
          if (operator === '%') {
            state.previousType = 'value';
            return 'operator right-operator';
          }

          state.previousType = 'operator';
          return 'operator';
        } else if (peek === ',') {
          if (state.insideFunction && state.previousType === 'value') {
            stream.next();
            state.previousType = 'comma';
            return 'comma';
          }
          return errorAndNext(stream, state, `Unexpected ','`);
        } else if (
          stream.match(
            /^(EDITED_FIELD|EDITED_FIELDID|EDITED_OLDVALUE|EDITED_NEWVALUE|CURRENT_TABLE_NAME|FORM_ID|CUSTOMFIELD_ID|CUSTOMFIELD_NAME|FIELD_TYPE|CURRENTUSER_ID|CURRENTUSER_FIRSTNAME|CURRENTUSER_LASTNAME|CURRENTUSER_PHONENUMBER|CURRENTUSER_USERNAME|PUBLICFORM)/
          )
        ) {
          if (!checkIfValueIsAllowed(stream, state)) {
            return error(stream, state, 'An operator is required before referencing a variable');
          }
          state.previousType = 'value';
          return 'environment-variable';
        } else if (stream.match(/^\$/)) {
          if (stream.match(/^[a-zA-Z_][a-zA-Z0-9_\.]*/)) {
            if (!checkIfValueIsAllowed(stream, state)) {
              return error(stream, state, 'An operator is required before the function');
            }

            if (stream.match(/(?=[(.])/, false)) {
              state.previousType = 'function-name';
              state.insideFunction = true;
              return 'function-name';
            }
            state.previousType = 'unfinished-formula';
            state.error = 'Syntax error';
            return 'unfinished-formula error';
          }
          return 'custom-function';
        } else if (stream.match(/^[a-zA-Z_][a-zA-Z0-9_\.]*/)) {
          if (!checkIfValueIsAllowed(stream, state)) {
            return error(stream, state, 'An operator is required before the function');
          }

          if (stream.match(/(?=[(.])/, false)) {
            state.previousType = 'function-name';
            state.insideFunction = true;
            return 'function-name';
          }
          state.previousType = 'unfinished-formula';
          state.error = 'Syntax error';
          return 'unfinished-formula error';
        } else if (peek === ']' && state.unclosedBrackets.length > 0 && state.unclosedBrackets[state.unclosedBrackets.length - 1].text === '[') {
          state.unclosedBrackets.pop();
          stream.next();

          if (stream.peek() === '!') {
            state.stack.unshift('table');
            state.isTable = true;
            state.previousTableType = 'table-end-bracket';
          }

          if (state.previousType === 'start-bracket') {
            state.previousType = 'error';
            return 'bracket error';
          }

          state.previousType = 'value';
          return 'bracket';
        } else if (peek === '(') {
          if (state.previousType !== 'function-name' && !checkIfValueIsAllowed(stream, state)) {
            return errorAndNext(stream, state, 'An operator is required before the parenthesis');
          }

          state.unclosedBrackets.push({ text: '(', type: state.previousType === 'function-name' ? 'function' : 'group', pos: stream.pos });
          stream.next();
          state.previousType = 'start-parenthesis';
          return 'bracket';
        } else if (peek === ')' && state.unclosedBrackets.length > 0 && state.unclosedBrackets[state.unclosedBrackets.length - 1].text === '(') {
          if (
            !(
              state.previousType === 'value' ||
              (state.previousType === 'start-parenthesis' && state.unclosedBrackets[state.unclosedBrackets.length - 1].type === 'function')
            )
          ) {
            return errorAndNext(stream, state, `Unexpected ')'`);
          }

          state.unclosedBrackets.pop();
          stream.next();
          state.previousType = 'value';

          if (!state.unclosedBrackets.some((x) => x.type === 'function')) {
            state.insideFunction = false;
          }

          return 'bracket';
        } else if ([']', ')'].indexOf(peek) !== -1) {
          return errorAndNext(stream, state, `Unexpected '${peek}'`);
        } else if (peek === ' ') {
          stream.next();
          return null;
        } else if (stream.eatSpace()) {
          stream.next();
          return null;
        }
        return errorAndNext(stream, state);
      }
    };
  });
})();

function checkIfOperatorIsAllowed(stream, state) {
  // Only allow operators after a value
  return state.previousType === 'value';
}

function checkIfValueIsAllowed(stream, state) {
  if (
    state.previousType === 'operator' ||
    state.previousType === 'comma' ||
    state.previousType === 'start-parenthesis' ||
    state.previousType === 'start-equals'
  ) {
    return true;
  }
  return false;
}

function error(stream, state, errorMessage?) {
  state.previousType = 'error';
  state.error = errorMessage;
  return 'error';
}

function errorAndNext(stream, state, errorMessage?) {
  stream.next();
  state.previousType = 'error';
  state.error = errorMessage;
  return 'error';
}

function handleTable(stream, state) {
  const peek = stream.peek();

  if (peek === '!' && state.previousTableType === 'table-end-bracket') {
    state.tableHasRange = false;
    state.previousTableType = '!';
    stream.next();
    return 'range-operator';
  } else if (state.previousTableType === 'column-function-name' && peek === '(') {
    state.previousTableType = 'column-function-start-parenthesis';
    stream.next();
    return 'bracket';
  } else if (state.previousTableType === 'column-function-start-parenthesis' && peek === ')') {
    state.previousTableType = 'column-value';
    stream.next();
    return 'bracket';
  } else if (state.previousTableType === 'row-function-name' && peek === '(') {
    state.previousTableType = 'row-function-start-parenthesis';
    stream.next();
    return 'bracket';
  } else if (state.previousTableType === 'row-function-start-parenthesis' && peek === ')') {
    state.previousTableType = 'row-value';
    stream.next();
    return 'bracket';
  } else if (peek === '[' && (state.previousTableType === '!' || state.previousTableType === 'range-operator')) {
    state.previousTableType = 'column-start-bracket';
    stream.next();
    return 'bracket';
  } else if (state.previousTableType === 'column-start-bracket') {
    if (stream.match(/[0-9]+(?=\])/)) {
      state.previousTableType = 'column-value';
      return 'number';
    } else if (stream.match(/(Column)(?=\(\)\])/)) {
      state.previousTableType = 'column-function-name';
      return 'function-name';
    } else if (stream.match(/^[a-zA-Z_]\w*/)) {
      state.previousTableType = 'unfinished-column-value';
      return 'unfinished-formula error';
    }
  } else if (peek === ']' && state.previousTableType === 'column-start-bracket') {
    state.previousTableType = 'column-end-bracket';
    stream.next();
    return 'bracket error';
  } else if (peek === ']' && (state.previousTableType === 'column-value' || state.previousTableType === 'column-function-name')) {
    state.previousTableType = 'column-end-bracket';
    stream.next();
    return 'bracket';
  } else if (peek === '[' && state.previousTableType === 'column-end-bracket') {
    state.previousTableType = 'row-start-bracket';
    stream.next();
    return 'bracket';
  } else if (state.previousTableType === 'row-start-bracket') {
    if (stream.match(/[0-9]+(?=\])/)) {
      state.previousTableType = 'row-value';
      return 'number';
    } else if (stream.match(/(Row)(?=\(\)\])/)) {
      state.previousTableType = 'row-function-name';
      return 'function-name';
    } else if (stream.match(/^[a-zA-Z_]\w*/)) {
      state.previousTableType = 'unfinished-row-value';
      return 'unfinished-formula error';
    }
  } else if (peek === ']' && state.previousTableType === 'row-start-bracket') {
    state.previousTableType = 'row-end-bracket';
    stream.next();
    return 'bracket error';
  } else if (peek === ']' && (state.previousTableType === 'row-value' || state.previousTableType === 'row-function-name')) {
    state.previousTableType = 'row-end-bracket';
    stream.next();

    if (!state.tableHasRange && stream.peek() === ':') {
      state.tableHasRange = true;
      state.nextCharacterIsRange = true;
    } else {
      // end the table
      state.stack.shift();
      state.previousType = 'value';
    }

    return 'bracket';
  } else if (peek === ':' && state.nextCharacterIsRange) {
    state.nextCharacterIsRange = false;
    state.previousTableType = 'range-operator';
    stream.next();
    return 'range-operator';
  }

  state.stack.shift();
  return errorAndNext(stream, state, 'Invalid table syntax');
}
